import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

const DeleteRecordModal = ({ target, label, onConfirm, onClose, deleting }) => (
    <Modal show={!!target} onHide={onClose} centered>
        <Modal.Header closeButton>
            <Modal.Title>Delete {label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Are you sure you want to delete <strong>{target?.user.first_name} {target?.user.last_name}</strong>? This will also remove their user account and cannot be undone.
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-secondary" onClick={onClose} disabled={deleting}>Cancel</Button>
            <Button variant="danger" onClick={onConfirm} disabled={deleting}>
                {deleting ? <><Spinner size="sm" animation="border" className="me-2" />Deleting…</> : 'Delete'}
            </Button>
        </Modal.Footer>
    </Modal>
);

export default DeleteRecordModal;
